import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';

import { OwnerWithEmailLink_order$key } from '__generated__/OwnerWithEmailLink_order.graphql';

type Props = {
  order: OwnerWithEmailLink_order$key;
};

const OwnerWithEmailLink: FC<Props> = ({ order }) => {
  const { id, email, owner } = useFragment(
    graphql`
      fragment OwnerWithEmailLink_order on Order {
        id
        email
        owner {
          name
          surname
        }
      }
    `,
    order
  );

  const nameData = [];

  if (owner?.name) {
    nameData.push(owner.name);
  }

  if (owner?.surname) {
    nameData.push(owner.surname);
  }

  const fullName = nameData.join(' ');

  const contentData = [];
  if (fullName) {
    contentData.push(fullName);
  }
  if (email) {
    contentData.push(email);
  }

  const content = contentData.join(', ');

  return <Link href={id}>{content}</Link>;
};

export default OwnerWithEmailLink;
